import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//declarated component
import { ReorderSectionFieldsComponent } from './reorder-section-fields.component';

//angular material
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';

//internal modules
import { SpinnerModule } from 'src/app/views/shared/components/spinner/spinner.module';


@NgModule({
  declarations: [
    ReorderSectionFieldsComponent
  ],
  imports: [
    CommonModule,

    //angular material
    DragDropModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatTooltipModule,

    //internal modules
    SpinnerModule,
  ],
  exports: [
    ReorderSectionFieldsComponent
  ]
})
export class ReorderSectionFieldsModule { }
